import { useLocation } from 'react-router-dom';
import { useEffect } from 'react';

const ScrollToHash = () => {
  const location = useLocation();

  useEffect(() => {
    if (location.hash) {
      const scrollToElement = () => {
        const element = document.querySelector(location.hash);
        if (element) {
          const elementPosition = element.getBoundingClientRect().top + window.pageYOffset;
          const offsetPosition = elementPosition;

          window.scrollTo({
            top: offsetPosition,
            behavior: 'smooth',
          });
        }
      };

      setTimeout(scrollToElement, 100);
    }
  }, [location]);

  return null;
}

export default ScrollToHash;
